// 创建文件en/index.js
const German = {
    my: "Mein",
    today: "Heute",
    this_week: "Diese Woche",
    this_month: "Diesen Monat",
    last_month: "Letzten Monat",
    this_year: "Dieses Jahr",
    number_of_people: "Anzahl der Personen",
    amount: "Betrag",
    enter_username_id_to_search: "Benutzernamen-ID eingeben, um zu suchen",
    team_list: "Teamliste",
    "Agent.Center": "Agentenzentrale",
    registration_time: "Registrierungszeit",
    selling_face_value: "Verkaufs nominalwert",
    click_for_details: "Klicken Sie für Details",
    "agent_login": "Agenten-Anmeldung",
    'SignOut': 'Abmelden',
    'Contact us': "Kontaktieren Sie uns",
    'Download our app': "Laden Sie unsere App herunter",
    'Download it from': "Download-URL",
    'About Us': "Gobuy USA wurde 2012 gegründet",
    'Gobuy USA was founded in 2012': "FAQ",
    'Customer service': "über uns",
    'frequently asked question': "Vertrieb und Lieferung",
    'Return and exchange policy': "Kundendienst",
    'Shipping and distribution': "Kontaktieren Sie uns per E-Mail",
    'Contact us by email': "Rückgabe- und Umtauschbedingungen",
    'Privacy Policy and Terms of Use': "Datenschutzrichtlinie und Nutzungsbedingungen",
    'Privacy Policy': "Datenschutzrichtlinie",
    'Terms of use': "Nutzungsbedingungen",
    'Upload credentials': "Anmeldeinformationen hochladen",
    'The withdrawal is being processed': "Auszahlung läuft",
    'Cause of failure': "Grund für das Scheitern",
    'Your shopping cart is still empty': "Ihr Warenkorb ist noch leer",
    'Log in to view the items in your cart': "Melden Sie sich an, um die Artikel im Warenkorb anzuzeigen",
    'Browse around': "Durchsuchen",
    'Account correlation': "Zahlungsadresse",
    'Order management': "Einstufung",
    'Payment method': "Kontobezogen",
    'Collection address': "Auftragsverwaltung",
    Category: "Zahlungsart",
    "MyCommission": "meine Provision",
    "Gross income": "Gesamtumsatz",
    "Direct commission": "direkte Provision",
    "Indirect commission": "indirekte Provision",
    "Transfer to wallet": "Auf Wallet übertragen",
    "Tip: The transfer amount must be greater than 10USDT": "Tipp: Der Überweisungsbetrag muss größer als 10USDT sein",
    "transfer": "überweisen",
    "commission": "Kommission",
    "Please enter": "Bitte treten Sie ein",
    "Team Commission": "Teamprovision",

    'Old Password': "Altes Passwort",
    'Change password': "Kennwort ändern",
    'Gobuy GIFT CARD': "Gobuy-Geschenkkarte",
    'High Priced Recycling': "Hochpreisiges Recycling",
    'Data': "Datum",
    'congratulations': "Glückwunsch",
    'Obtain': "erhalten",
    'ThankYouForParticipating': "Vielen Dank für Ihre Teilnahme",

    // navbar"",
    Home: "Titelseite",
    Search: "suchen",
    ShoppingCart: "Warenkorb",
    Mine: "meins",

    // 首页
    // 搜索
    EnterSearchContent: "Geben Sie Suchinhalte ein",
    'Recent searches': "Aktuelle Suchanfragen",
    'popular searches': "Beliebte Suchanfragen",
    'Please search': "Bitte geben Sie die Schlüsselwörter ein, nach denen Sie suchen möchten",
    'orderSearch': "Geben Sie den Bestell- oder Produktnamen ein, um zu suchen",

    // 语言
    'Language selection': "Sprachauswahl",

    // menu
    Brand: "Marke",
    Collect: "sammeln",
    Manage: "verwalten",
    Order: "Befehl",
    Wallet: "Geldbörse",
    BlindBox: "Blindbox",
    MenuGiftCard: "Geschenkkarte",
    // HotSale
    HotSale: "Die neuesten Nachrichten sind im Angebot...",
    // tabs"",
    TodaysOffer: "Plattformempfehlung",
    'Phone': "Handy",
    'Smart Watch': "Smartwatch",
    'Smart bracelet': "intelligentes Armband",

    // gobuy
    'home.gobuy.title': "Überraschungen warten auf Sie",
    'home.gobuy.periods': "Blindbox rund",
    'home.gobuy.freeze': "Nehmen Sie am Countdown teil",
    'home.gobuy.drawing': "Countdown starten",
    'home.gobuy.buy': "teilnehmen",
    'home.gobuy.isbuy': "Habe bereits teilgenommen",
    
    'home.gobuy.jackpot': "Preispool",
    Purse: "Geldbörse",
    Box: "Blindbox",
    'GetAPrize': "Holen Sie sich Preise",
    Discount: "Rabatt",
    when: "Wann",
    points: "Integral",
    seconds: "Zweite",
    // MessageBox
    'MessageBox.Tips': "Hinweis",
    'MessageBox.Confirm': "bestätigen",
    'MessageBox.Cancel': "Stornieren",
    'MessageBox.buy.box': "Sind Sie sicher, dass Sie diese Blindbox kaufen möchten?",
    // Toast
    'succ': "Erfolg",
    'err': "Fehler",
    'box.succeeds': "Kauf erfolgreich",
    'box.frozen': "Habe bereits teilgenommen",
    'box.issue': "Pro Ausgabe kann nur eine Blindbox erworben werden",

    // 商品列表
    filter: "Filter",
    sales: "Verkaufsvolumen",
    selfOP: "Selbstbetrieben",
    noMore: "nicht mehr",
    brand: "Marke",
    confirm: "bestätigen",
    reset: "zurücksetzen",
    ComSor: "Umfassende Sortierung",
    MostPop: "am beliebtesten",
    HighLow: "Preis von hoch nach niedrig",
    LowHigh: "Preis von niedrig bis hoch",
    SalVol: "Verkaufsvolumen",
    NewArr: "Neu eingetroffen",

    // 购物车
    'cart.cart': "Warenkorb",
    'cart.edit': "bearbeiten",
    'cart.done': "Beenden",
    'home.cart.voucher': "Holen Sie sich Gutscheine",
    'home.cart.outstock': "ausverkauft",
    'home.cart.offshelf': "Aus den Regalen entfernt",
    'Only': "nur",
    'left': "individuell",
    'Promotion': "Förderung",
    'cart.all': "Alles auswählen",
    'cart.total': "gesamt",
    'cart.delete': "löschen",
    'cart.checkout': "Die Rechnung, bitte",

    // 我的
    'Direct': "direkt",
    'Indirect': "indirekt",
    'MyOrders': "meine Bestellung",
    'ViewAll': "Alle anzeigen",
    'Unpaid': "Ausstehende Zahlung",
    'ToShip': "Warten auf Versand",
    'ToReceive': "Warte auf Erhalt",
    'ToReview': "Warten auf Bewertung",
    // 盲盒
    'MyBlindBox': "Blindbox-Liste",
    'WaitingDraw': "Warten auf die Auslosung",
    'Opened': "Geöffnet (Empfang/Rückgabe)",
    // 礼品卡
    'After sale': "After-Sales",
    'GiftCard': "Schallplatten recyceln",
    'RecycleGiftCard': "Geschenkkarten recyceln",
    'Verifying': "überprüfen",
    'Rebuying': "Nachkauf",
    'Repurchased': "Warten auf Zahlung",
    'Paid': "Die Zahlung ist erfolgt",
    // 常用工具
    'CommonTools': "Gängige Werkzeuge",
    'MyWallet': "meine Brieftasche",
    'VirtualOrders': "virtuelle Ordnung",
    'Refunds': "Erstattung",
    'MyFriends': "meine Freunde",
    'ChatList': "Chat-Liste",
    'RealNameVerification': "Authentifizierung mit echtem Namen",
    'MyFavorites': "meine Sammlung",
    'Addresses': "Adressverwaltung",
    'MyReviews': "Meine Rezension",
    'BrowsingHistory': "Durchsuchen Sie den Verlauf",
    'Promotions': "Werbeaktionen",
    'StoreManagement': "Filialleitung",
    'BecomeASeller': "Werden Sie Verkäufer",

    // 订单列表
    'SearchPlaceholder': "Geben Sie den Produktnamen der Bestellung ein, um zu suchen",
    All: "alle",
    OrderNo: "Bestellnummer",
    items: "Stücke",
    ShippingFee: "Fracht",
    'Refund in Progress': "Rückerstattung läuft",
    'Cancel Order': "Bestellung stornieren",
    'Refund': "Erstattung",
    'Track Shipping': "Überprüfen Sie die Logistik",
    'Confirm Receipt': "den Wareneingang bestätigen",
    'Evaluate': "auswerten",
    'Delete': "löschen",
    'Pay': "Zahlung",
    'MessageBox.delete.order': "Sind Sie sicher, dass Sie diese Bestellung löschen möchten?",
    'MessageBox.cancel.order': "Sind Sie sicher, dass Sie diese Bestellung stornieren möchten?",
    'MessageBox.receive.order': "Ist diese Bestellung eingegangen?",
    // 订单详情
    'Order Details': "Bestelldetails",
    'Pickup Code': "Abholcode",
    'Complaint': "Beschwerde",
    'After-Sales': "After-Sales",
    'Gift': "Geschenk",
    'Order Date': "Bestelldatum",
    'Used voucher worth': "Betrag des verwendeten Gutscheins",
    'CNY': "RMB",
    'Payment Method': "Zahlungsart",
    'Total Product Amount': "Gesamtproduktmenge",
    'Shipping Fee': "Fracht",
    'Amount Paid': "Gezahlter Betrag",
    'Return': "die Ware zurückschicken",
    // 盲盒列表
    'Pending Draw': "Warten auf die Verlosung der Lotterie",
    'Pending Unboxing': "Zu öffnen",
    'Unboxed': "Bereits eingeschaltet",
    'Collected': "Erhalten",
    'Recycled': "Recycelt",
    'Unknown': "unbekannt",
    'Claim': "erhalten",
    'Recycle': "Rückkauf",
    'Unbox': "einschalten",
    'MessageBox.recycle.box': "Sind Sie sicher, dass Sie diese Blindbox recyceln möchten?",
    // 盲盒详情
    'Mystery Box Details': "Details zur Blindbox",
    'Unopened': "Nicht eingeschaltet",
    'box.opened': "Nicht eingeschaltet",
    'Claimed': "Erhalten",
    'Confirm Claim': "Abholung bestätigen",
    'MessageBox.pick.box': "Sind Sie sicher, dass Sie diese Blindbox extrahieren möchten?",
    // 盲盒提货
    'Please add address': "Bitte Adresse hinzufügen",
    // 礼品卡列表
    'Face Value Total': "Gesamtnennwert",
    // 礼品卡详情
    'Gift Card Details': "Details zur Geschenkkarte",
    'Card number': "Kartennummer",
    'Activation code': "Aktivierungscode",
    'Actual recovery price': "tatsächlicher Recyclingpreis",
    // 礼品卡回收
    'Gift Card Recycling': "Recycling von Geschenkkarten",
    'Confirm Recycling': "Bestätigen Sie das Recycling",
    'Please enter the card number': "Bitte Kartennummer eingeben",
    'Please enter the activation code': "Bitte geben Sie den Aktivierungscode ein",
    'MessageBox.recycle.gift': "Sind Sie sicher, dass Sie diese Geschenkkarte recyceln möchten?",

    // 我的钱包
    'My Wallet': "meine Brieftasche",
    'Available Balance': "verfügbares Guthaben",
    'Gift Balance': "Geschenkguthaben",
    'All': "Alle",
    'Next event loading': "Die nächste Veranstaltung wird geladen",
    'Frozen Funds': "Gelder einfrieren",
    'Recharge': "nachfüllen",
    "can": "Kann",
    'Withdraw': "Bargeld abheben",
    'Withdrawal Accounts': "Konto abheben",
    // 充值
    'Recharge Details': "Details zum Aufladen",
    'Recharge Order No.': "Bestellnummer aufladen",
    'Recharge Amount': "Aufladebetrag",
    'Creation Time': "Schöpfungszeit",
    'MessageBox.recharge.pop': "Bitte geben Sie den Aufladebetrag ein",
    // 付款
    'payment': "Zahlung",
    'Order submitted successfully, please select payment method': "Bestellung erfolgreich übermittelt, bitte wählen Sie die Zahlungsart aus",
    'Rechargeable card': "wiederaufladbare Karte",
    'Please enter a hash': "Bitte Hash eingeben",
    'Immediate payment': "Bezahlen Sie jetzt",
    'Wait for the file to load': "Bitte warten Sie, bis die Datei geladen ist",
    // 提现
    'Withdrawal Details': "Details zur Auszahlung",
    'Withdrawal Amount': "Betrag abheben",
    'Application Time': "Bewerbungszeitpunkt",
    'New Application': "neue Anwendung",
    'Payment Password': "Zahlungspasswort",
    'New Payment Password': "Neues Zahlungspasswort",
    'Recipient Information': "Informationen zum Zahlungsempfänger",
    'Submit': "einreichen",
    'Add Recipient Account First': "Bitte fügen Sie zunächst ein Zahlungskonto hinzu",
    'Please bind your mobile phone or email first': "Bitte binden Sie zuerst Ihr Mobiltelefon oder Ihre E-Mail-Adresse ein",
    // 设置
    'Account Settings': "Kontoeinstellungen",
    'Change Login Password': "Login-Passwort ändern",
    'Change Payment Password': "Zahlungspasswort ändern",
    'Log Out': "Abmelden",
    'Mobile': "Handy",
    'Verification Code': "Bestätigungscode",
    'Email': "Post",
    'New Password': "Neues Passwort",
    'Confirm Password': "Passwort bestätigen",
    'Modify': "Überarbeiten",
    'Bind': "Bindung",
    ' Mobile': "Handy",
    ' Email': "Post",
    // 资金详情
    'Fund Details': "Einzelheiten zur Finanzierung",
    'Withdrawal Account': "Konto abheben",
    'Account Type': "Kontotyp",
    'USDT Address (opBNB)': "USDT-opBNB",
    'Edit': "bearbeiten",
    'Delete': "löschen",
    'Add New': "Neues Konto hinzufügen",
    'MessageBox.delete.bank': "Sind Sie sicher, dass Sie dieses Auszahlungskonto löschen möchten?",
    // 登录
    'Login': "Einloggen",
    'Sign Up': "registrieren",
    'Normal Login': "Normale Anmeldung",
    'Username / Email / Phone Number': "Benutzername/E-Mail",
    'Enter Phone Number': "Bitte geben Sie die Mobiltelefonnummer ein",
    'Enter Email': "Bitte geben Sie Ihre E-Mail-Adresse ein",
    'Enter SMS Code': "Bitte geben Sie den SMS-Bestätigungscode ein",
    'Enter Password': "Bitte geben Sie das Passwort ein",
    "enter_login_password_for_verification": "Bitte geben Sie Ihr Anmeldepasswort zur Verifizierung ein",
    'Forgot Password': "vergessen Sie das Passwort",
    'Third-party Login': "Anmeldung für Dritte",
    'Please complete the form': "Bitte füllen Sie das Formular aus",
    'WeChat': "WeChat",
    'Weibo': "Weibo",
    'QQ': "QQ",
    'phone login': "Mobile Anmeldung",
    'Login Expired': "Die Anmeldung ist abgelaufen",
    'Please enter your phone number first': "Bitte geben Sie zuerst Ihre Handynummer ein",
    'Please enter your username/email/phone number': "Bitte geben Sie Benutzernamen/E-Mail ein",
    'Please enter your password': "Bitte geben Sie das Passwort ein",
    'Password must be at least 6 characters': "Das Passwort muss mindestens 6 Zeichen lang sein",
    'Please enter an 11-digit phone number': "Bitte geben Sie Ihre 11-stellige Mobiltelefonnummer ein",
    'Please wait for the file to finish loading': "Bitte warten Sie, bis die Datei geladen ist",
    'send': "schicken",
    'signUpTips': "Ihre persönlichen Daten werden verwendet, um Ihr Erlebnis auf der Website zu verbessern, den Zugriff auf Ihr Konto zu verwalten und für andere in unserer Datenschutzrichtlinie beschriebene Zwecke.",

    // 注册
    'Sign Up': "registrieren",
    'Referrer': "Empfehlungsgeber",
    'Invitation code': "Einladungscode",
    'Please.enter.Invitation.code': 'Bitte geben Sie den Einladungscode ein',
    'Email.verification.code': 'E-Mail-Bestätigungscode',
    'Invite friends': "Freunde einladen",
    'Username': "Benutzername",
    'Full Name': "richtiger Name",
    'Set Password': "Passwort festlegen",
    'Confirm Password': "Passwort bestätigen",
    'Phone Number': "Telefonnummer",
    'Email': "E-Mail",
    'Username: 3-25 chars, letters & numbers': "Benutzername: 3-25 Zeichen, Buchstaben und Zahlen",
    '6-20 digits/letters/symbols': "6–20 Ziffern/Buchstaben/Symbole",
    'By clicking sign up, you agree to': "Indem Sie auf „Registrieren“ klicken, stimmen Sie zu",
    'User Agreement': "Benutzervereinbarung",
    'Please check the user agreement': "Bitte überprüfen Sie die Nutzungsvereinbarung",
    'Please enter a username with 3-25 characters': "Bitte geben Sie einen Benutzernamen mit 3-25 Zeichen ein",
    'Enter SMS Verification Code': "Bitte geben Sie den SMS-Bestätigungscode ein",
    'Please enter your phone number': "Bitte geben Sie Ihre Handynummer ein",
    'Please enter the verification code': "Bitte geben Sie den Bestätigungscode ein",
    'Please enter a 6-digit verification code': "Bitte geben Sie den 6-stelligen Bestätigungscode ein",
    'Please enter a password with 6-20 characters': "Bitte geben Sie ein 6-20 Zeichen langes Passwort ein",
    'Please enter the confirm password': "Bitte geben Sie das Bestätigungspasswort ein",
    'The confirm password does not match the entered password': "Das Bestätigungspasswort stimmt nicht mit dem eingegebenen Passwort überein",

    // 密码恢复
    'Password Recovery': "Passwortwiederherstellung",
    'Forgot Password': "vergessen Sie das Passwort",
    'Forget.email.tips': "Wenn Ihrem Konto noch keine E-Mail-Nummer zugeordnet ist, wenden Sie sich bitte an den Plattformadministrator, um Ihr Passwort wiederherzustellen.",

    // 通知
    'Notification Message': "Benachrichtigungsnachricht",
    'Direct Message': "private Nachricht",
    'System Message': "Systemmeldungen",
    'Leave a Message': "Nachricht",

    // 配送地址
    'Delivery Address': "Lieferadresse",
    'The store is no longer valid, please edit the delivery address again': "Dieser Shop ist nicht mehr gültig. Bitte bearbeiten Sie die Lieferadresse erneut",
    'Default address': "Standardadresse",
    'Add address': "Adresse hinzufügen",
    'Edit address': "Adresse bearbeiten",
    'MessageBox.delete.address': "Sind Sie sicher, dass Sie diese Adresse löschen möchten?",
    'name': "Name",
    'phone': "Telefonnummer",
    'district': "Bezirk",
    'address': "Adresse",
    'default address': "Standardadresse",
    'save and use': "Speichern und verwenden",
    'save': "speichern",
    'Please select a region': "Bitte wählen Sie eine Region aus",
    'Please fill in the recipient name': "Bitte geben Sie den Namen des Empfängers ein",
    'Name must be 2-15 characters': "Der Name muss 2–15 Zeichen lang sein",
    'Please fill in the mobile phone number': "Bitte geben Sie die Mobiltelefonnummer ein",
    'Please select your location': "Bitte wählen Sie Ihren Standort aus",
    'Please fill in the detailed address': "Bitte geben Sie die detaillierte Adresse ein",

    // 浏览历史
    'Browsing History': "Durchsuchen Sie den Verlauf",
    'Clear browsing history': "Browserverlauf löschen",

    // 推广会员
    'Promotion member': "Mitglieder fördern",
    "PromotionPoster": "Werbeplakat",
    "MemberName": "Mitgliedsname",
    "MyAssets": "mein Vermögen",
    "DistributedAmount": "Ausschüttungsbetrag",
    "NumberOfDistributedProducts": "Produktmenge zuordnen",
    "DistributedProductAmount": "Ausschüttungsbetrag",
    "MyTeam": "mein Team",
    "LevelOneMembers": "erstklassiges Mitglied",
    "LevelTwoMembers": "Mitglied der zweiten Ebene",
    "PromotionPoster": "Werbeplakat",
    "PromotionMembers": "Mitglieder fördern",
    "PromotionPerformance": "Werbeleistung",
    "ViewPromotionLink": "Klicken Sie hier, um den Aktionslink anzuzeigen",
    "PromoteViaWeChatQRCode": "Bewerben Sie über den WeChat-QR-Code",
    "Copy": "Kopie",
    "BrowserNotSupportedCopyManually": "Ihr Browser unterstützt das direkte Kopieren nicht. Bitte kopieren Sie es manuell",
    "GiftCardRecoveryTotal": "Gesamtzahl der recycelten Geschenkkarten",
    "TodaysGiftCardRecoveryCount": "Die heutige Zählung zum Recycling von Geschenkkarten",
    "RegistrationDate": "Anmeldedatum",
    "LastLogin": "letzte Anmeldung",
    "Promotion Commission": "Werbeprovision",

    // userinfo 个人信息
    "Personal Info": "persönliche Informationen",
    "Nickname": "Spitzname",
    "Birthdate": "Geburtsdatum",
    "Save": "speichern",
    "CropImage": "Bild zuschneiden",
    "UseImage": "Verwenden Sie Bilder",

    // goodsDetail 商品详情
    "Off": "Rabatt",
    "Sold": "verkauft",
    "Product": "Produkt",
    "Comment": "Kommentar",
    "Details": "Einzelheiten",
    "ReportViolation": "Bericht",
    "Cart": "Warenkorb",
    "ChatMessages": "Chat-Nachrichten",
    "MyShop": "mein Laden",
    "MerchantLogin": "Händler-Login",
    "Share": "Aktie",
    "ShareTo": "Teilen mit",
    "WeChat": "WeChat",
    "Copy": "Kopie",
    "Poster": "Poster",
    "BrowserNotSupportedCopyManually": "Ihr Browser unterstützt das direkte Kopieren nicht. Bitte kopieren Sie es manuell",
    "Follow": "konzentrieren Sie sich auf",
    "Unfollow": "Nicht mehr folgen",
    "PleaseSelectQuantityAndCategory": "Bitte wählen Sie Menge und Kategorie aus.",
    "SelectedWithQuantity1": "Ausgewählte {Spezifikation}, Menge {Nummer}.",
    "SelectedQuantity1": "Ausgewählte Menge {Nummer}.",
    "SelectedWithQuantity2": "Ausgewählte {Spezifikation}, Menge {Nummer}.",
    "Add to cart": "in den Warenkorb legen",
    "Buy now": "Kaufe es jetzt",
    "Stock": "auf Lager",
    "Pieces": "Stücke",
    "Quantity": "Menge",
    "All": "alle",
    "Good": "Gute Bewertungen",
    "Medium": "Neutrale Bewertung",
    "Bad": "Schlechte Bewertung",
    // 评论
    "Product review": "Produktbewertungen",
    "anonymous": "anonym",
    "noReviewInfo": "Keine Kommentarinformationen angegeben",
    "Shop Owners Response": "Der Ladenbesitzer antwortet",
    "This product has no current reviews": "Für dieses Produkt liegen derzeit keine Bewertungen vor",
    "Product details": "Produktdetails",
    "shop": "Geschäft",
    "customerService": "Warenkorb",
    "shoppingCart": "in den Warenkorb legen",
    "addToCart": "Kaufe es jetzt",
    "buyNow": "Das ausgewählte Produkt ist derzeit leider nicht vorrätig!",
    "outOfStock": "Das ausgewählte Produkt ist leider nicht mehr verfügbar!",
    "notAvailable": "Shop-Bestellnachrichten",
    "Store order message": "Bestellung bestätigen",
    "Confirm the order": "Produktmenge",
    "productAmount": "Rabatt",
    "discount": "Fracht",
    "shippingFee": "Zwischensumme speichern",
    "subtotal": "Bestellung absenden",
    "Submit an order": "Rückerstattung hinzufügen",
    // 退货
    "refundAdd": "zurückkehren",
    "back": "Rückerstattungsanweisungen:",
    "refundDescription": "Rückerstattungsgutschein",
    "proofOfRefund": "verwenden",
    "use": "Kundendienst",


    // 一元购
    "yi1": `Ein-Euro-Kauf`,
    "yi2": `Preisbereich`,
    "yi3": `Bereich`,
    "yi4": `Kaufhistorie`,
    "yi5": `Erhaltene Produktaufzeichnungen`,
    "yi6": `Einlöscode ansehen`,
    "yi7": `Auszahlung beantragen`,
    "yi8": `Aufladen`,
    "yi9": `Teilnahmemenge`,
    "yi10": `Gesamtmenge`,
    "yi11": `Fehlende Menge`,
    "yi12": `Jetzt kaufen`,
    "yi13": `Weiter kaufen`,
    "yi14": `Andere Bereiche`,
    "yi15": `Mehr laden`,
    "yi16": `Demnächst verfügbar...`,
    "yi17": `Bereich`,
    "yi18": `Runde`,
    "yi19": `Zeitraum`,
    "yi20": `Preis: `,
    "yi21": `Mehr laden`,
    "yi22": `Schnellzahlung – Informationen zu Ihrem gewünschten Produkt`,
    "yi23": `Menge kaufen`,
    "yi24": `(Je mehr Sie kaufen, desto höher ist Ihre Chance, das Produkt zu gewinnen!)`,
    "yi25": `Gesamt: `,
    "yi26": `Zahlung erfolgreich`,
    "yi27": `Zahlung fehlgeschlagen`,
    "yi28": `Grund: `,
    "yi29": `Ergebnisse enthüllt`,
    "yi30": `Glückskauf-Code`,
    "yi31": `Produktgewinner`,
    "yi32": `Herzlichen Glückwunsch, Sie haben dieses Produkt gewonnen`,
    "yi33": `Offenlegungszeit: `,
    "yi34": `Kaufzeit: `,
    "yi35": `Gesamte Anzahl der vom Gewinner gekauften Artikel: `,
    "yi36": ` Kaufcode:`,
    "yi37": `Abholung`,
    "yi38": `Einlösen`,
    "yi39": `Vorbestellen`,
    "yi40": `Kaufen`,
    "yi41": `Aufzeichnungen über erhaltene Produkte`,
    "yi42": `Gewinntermin: `,

    "hunt1": `Einlösecode`,
    "hunt2": `Viel Glück`,
    "hunt3": `Unaufhaltsam`,
    "hunt4": `Einlöscode`,
    "hunt5": `Einlöscode: `,
    "hunt6": `Mehr laden`,
    "hunt7": `Ich möchte einlösen`,
    "hunt8": `Bitte Einlöscode eingeben`,
    "hunt9": `Einlösungspreis beträgt 90 % des Verkaufspreises`,
    "hunt10": `Produktliste`,
    "hunt11": `Bereich`,
    "hunt12": `Sprache`,
    "hunt13": `Ankündigung`,
    "hunt14": `Navigation`,
    "hunt15": `Offizielle Ankündigung`,
    "hunt16": `Schatzaufzeichnungen`,
    "hunt17": `Versandregeln`,
    "hunt18": `Regelerklärung`,
    "hunt19": `Ich möchte einlösen`,
    "hunt20": `Kontaktieren Sie uns`,
    "hunt21": `E-Mail`,
    "hunt22": `Ziehungsregeln`,
    "hunt23": `Regelübersicht`,
    "hunt24": `1. Nummernvergabe: `,
    "hunt25": `Für jede Zahlung von 0,1 USDT erhält der Benutzer eine Glücksnummer, beginnend mit 000001, die der Reihe nach vergeben wird, bis die Zielanzahl der Teilnehmer erreicht ist (z. B. 1000).`,
    "hunt26": `2. Ziehungsbedingungen: `,
    "hunt27": `Sobald das Produkt die Zielanzahl der Teilnehmer erreicht hat (z. B. 1000), beginnt der Ziehungsprozess.`,
    "hunt28": `3. Ziehungszeit: `,
    "hunt29": `Nach der Bestätigung der letzten Bestellung warten Sie auf die nächste Blockchain-Zeit, die auf 05, 10, 15, 25, 30, 35, 40, 45, 50, 55 oder eine volle Stunde endet.`,
    "hunt30": `4. Berechnung der Gewinnnummer: `,
    "hunt31": `1. Extrahieren Sie reine Zahlen aus dem Block-Hash und berechnen Sie das Modulo basierend auf der Gesamtzahl der Teilnehmer:
                Gewinnnummer = (Reine Zahlen aus Hash % Gesamtzahl der Teilnehmer) + 1`,
    "hunt32": `2. Das berechnete Ergebnis entspricht der Gewinnnummer.`,
    "hunt33": `Teilnahmestufe`,
    "hunt34": `Benutzer erhalten für jede Zahlung von 0,1 USDT eine Glücksnummer.`,
    "hunt35": `Wenn das Produkt die Zielanzahl der Teilnehmer erreicht, werden keine neuen Beiträge mehr akzeptiert.`,
    "hunt36": `Ziehungsstufe`,
    "hunt37": `Zeichnen Sie die genaue Zeit der letzten Bestellung auf (z. B. 15:47:23).`,
    "hunt38": `Warten Sie, bis der nächste Blockchain-Block generiert wird, dessen Zeit den Regeln entspricht:`,
    "hunt39": `Blockchain-Zeit, die auf 05, 10, 15, 25, 30, 35, 40, 45, 50, 55 oder eine volle Stunde endet (z. B. 15:50:00).`,
    "hunt40": `Holen Sie sich den Block-Hash, der den Bedingungen entspricht.`,
    "hunt41": `Gewinnstufe`,
    "hunt42": `Extrahieren Sie reine Zahlen aus dem Block-Hash.`,
    "hunt43": `Beispiel für einen Block-Hash: 0000000000000000000a16b6f44536e521000000adbcf3f4b2ec018ffabcd123`,
    "hunt44": `Extrahierte reine Zahlen: 16644536521000000342018123`,
    "hunt45": `Modulo Gesamtzahl der Teilnehmer: `,
    "hunt46": `Gewinnnummer`,
    "hunt47": `= (Extrahierte Zahl % Gesamtzahl der Teilnehmer) + 1 `,
    "hunt48": `Wenn die extrahierte Zahl 16644536521000000342018123 beträgt und die Gesamtzahl der Teilnehmer 1000 beträgt: `,
    "hunt49": `= (16644536521000000342018123 % 1000) + 1 = 123 + 1 = 124`,
    "hunt50": `Ergebnisse veröffentlichen`,
    "hunt51": `Die Plattform gibt die Gewinnnummer und die entsprechenden Benutzerinformationen bekannt.`,
    "hunt52": `Bietet auch den vollständigen Berechnungsprozess (Bestellzeit, verwendeter Block-Hash, extrahierte Zahlen und Berechnungsformel für die Gewinnnummer).`,
    "hunt53": `Vorteile`,
    "hunt54": `1. Fairness`,
    "hunt55": `Die Verwendung öffentlicher Blockchain-Hashes garantiert, dass die Ziehungsergebnisse unvorhersehbar und manipulationssicher sind.`,
    "hunt56": `2. Transparenz`,
    "hunt57": `Benutzer können die Hash-Werte und den Nummernvergabeverlauf überprüfen.`,
    "hunt58": `3. Hohe Effizienz`,
    "hunt59": `Ergebnisse können schnell durch Warten auf den entsprechenden Block ermittelt werden.`,
    "hunt60": `Details zur Ankündigung`,
    "hunt61": `Kaufmenge: `,
    "hunt62": `Teile`,
    "hunt63": `Klicken Sie hier, um Kaufcodes anzuzeigen`,
    "hunt64": `Kaufcode: `,
    "hunt65": `Regelerklärung`,
    "hunt66": `Über Bestellungen`,
    "hunt67": `Um sicherzustellen, dass Sie Ihre Produkte schnell erhalten, werden Bestellungen, die vor 16:00 Uhr aufgegeben werden, am selben Tag mit XX Kurier oder XX Kurier versendet. Für Expressversand kontaktieren Sie den Kundenservice, um den Differenzbetrag für XX Kurier zu zahlen. Andere Kurierdienste werden derzeit nicht unterstützt.`,
    "hunt68": `Über Rechnungen`,
    "hunt69": `Alle verkauften Produkte können mit elektronischen Rechnungen ausgestellt werden. Sie können den Kundenservice über Ihre Bestellung kontaktieren und die Rechnungsinformationen bereitstellen. In der Regel werden Rechnungen innerhalb von 1-3 Tagen ausgestellt. An Feiertagen verzögert sich die Ausstellung entsprechend.`,
    "hunt70": `Glückskauf`,


    "new1": "Beispiel",
    "new2": "Das Produkt erfordert 1000 Teilnehmer. Die letzte Bestellzeit ist 15:47:23.\nDie dem Ziehungszeitpunkt am nächsten liegende Blockzeit ist 15:50:00",
    "new3": "Der Block-Hashwert lautet:",
    "new4": "Extrahieren der reinen Ziffern aus dem Hashwert:",
    "new5": "Berechnung der Gewinnnummer:",
    "new6": "Gewinnnummer",
    "new7": "Die Gewinnnummer lautet 124, der entsprechende Nutzer ist der Gewinner.",
    "new8": `Eingelöst`,
    "new9": `Nicht eingelöst`,
    "new10": `Leider haben Sie nicht gewonnen`,
    "new11": `Herzlichen Glückwunsch`,
    "new12": `Den Artikel dieser Runde gewonnen`,
    "new13": `Einlösen`,
    "new14": `Glückskauf`,
    "new15": `Artikel abgeholt`,


    "new16": "Waren abholen bestätigen?",
    "new17": "Eintausch bestätigen?",
    "copyS": "Kopieren erfolgreich",
    "copyE": "Kopieren fehlgeschlagen",
    "new18": "Produktanzeige",
    "new19": "Vorherige Seite",
    "new20": "Nächste Seite",
    "new21": "Zu",
    "new22": "Seite",
    "new23": "Bestätigen",
    "new24": "Warten auf Ziehung",

    "tool1": "Startseite",
    "tool2": "Produkte",
    "tool3": "Nachrichten",
    "tool4": "Jagdprotokolle",
    "tool5": "Versand",
    "tool6": "Regeln",
    "tool7": "Eintauschen",
    "tool8": "Kontakt",

    "new25": "Produkteinlösung",
    "new26": "Bitte geben Sie Ihren gobuy-Benutzernamen ein",


    "ship1": "Geltungsbereich",
    "ship2": "Diese Versandregeln gelten für alle Bestellungen auf der E-Commerce-Plattform luckybuy. Da die Plattform nur USDT-Zahlungen akzeptiert, werden Kreditkartenzahlungen, Barzahlungen oder Frachtabzüge nicht unterstützt. Die folgenden Regeln werden hiermit festgelegt.",
    "ship3": "1. Versandregeln innerhalb der Vereinigten Staaten",
    "ship4": "Zahlungsmethoden",
    "ship5": "Es wird nur USDT-Zahlung akzeptiert. Kreditkartenzahlung und Barzahlung werden nicht unterstützt.",
    "ship6": "Nachnahmeservice",
    "ship7": "Der Nachnahmeservice ist nur für Kunden in den Vereinigten Staaten verfügbar. Eine Vorauszahlung der Versandkosten ist nicht erforderlich.",
    "ship8": "Versandrichtlinien",
    "ship9": "Der Bestellbetrag enthält keine Versandkosten, diese müssen separat bezahlt werden.",
    "ship10": "Liefergebiet",
    "ship11": "Lieferungen werden in das gesamte Festland der Vereinigten Staaten unterstützt.",
    "ship12": "Kundenhinweis",
    "ship13": "Nach Aufgabe einer Bestellung müssen die Kunden sicherstellen, dass ihre Kontaktdaten korrekt sind. Die Waren müssen zum Zeitpunkt der Lieferung vom Kunden oder einem bevollmächtigten Vertreter unterschrieben werden.",
    "ship14": "2. Versandregeln außerhalb der Vereinigten Staaten",
    "ship15": "Es wird nur USDT-Zahlung akzeptiert. Kreditkartenzahlung und Barzahlung werden nicht unterstützt.",
    "ship16": "Kunden außerhalb der Vereinigten Staaten müssen nach Abschluss der Bestellung eine zusätzliche Zahlung für die Versandkosten leisten.",
    "ship17": "Sobald die zusätzliche Zahlung für den Versand erfolgt ist, wird die Plattform den Versand veranlassen.",
    "ship18": "Nachnahmerichtlinie",
    "ship19": "Ein Nachnahmeservice wird nicht angeboten. Kunden außerhalb der Vereinigten Staaten müssen die Versandkosten vollständig zahlen, bevor die Bestellung bearbeitet wird.",
    "ship20": "Prozess für zusätzliche Versandkosten",
    "ship21": "Nach der Bestellung berechnet die Plattform die Versandkosten basierend auf der Kundenadresse und informiert den Kunden, den zusätzlichen Betrag per USDT zu bezahlen.",
    "ship22": "Sobald die Zahlung für den Versand abgeschlossen ist, veranlasst die Plattform den Versand und stellt Informationen zur Sendungsverfolgung bereit.",
    "ship23": "Lieferungen werden in alle Länder weltweit unterstützt. Die genaue Lieferzeit hängt von den örtlichen Logistikbedingungen ab.",
    "ship24": "Die Kunden müssen sicherstellen, dass die Adresse und Kontaktdaten korrekt sind. Jegliches Scheitern der Lieferung aufgrund falscher Angaben liegt in der Verantwortung des Kunden.",
    "ship25": "Die Plattform ist nicht für Zollbestimmungen im Bestimmungsland verantwortlich. Kunden müssen sich eigenständig um die Zollabfertigung und eventuelle zusätzliche Gebühren kümmern.",
    "ship26": "Hinweise",
    "ship27": "1. Sobald eine Bestellung erfolgreich bezahlt wurde, kann sie nicht mehr storniert oder erstattet werden. Kunden sollten daher die Bestelldaten vor der Zahlung sorgfältig prüfen.",
    "ship28": "2. luckybuy haftet nicht für Probleme infolge höherer Gewalt während des Transports (z. B. Naturkatastrophen oder politische Veränderungen), wird jedoch sein Möglichstes tun, um Kunden bei der Lösung zu unterstützen.",
    "ship29": "3. Bei Fragen wenden Sie sich bitte an den Kundendienst unserer Plattform.",
    "ship30": "Vielen Dank für Ihr Verständnis und Ihre Unterstützung!",
    "ship31": "luckybuy ist bestrebt, Ihnen bestmöglich zu dienen.",

    // 礼品卡相关
    'Original Price':'Ursprünglicher Preis',
    'Actual Payment':'Tatsächliche Zahlung',
    'Balance':'Guthaben',
    'MessageBox.buy.card': 'Möchten Sie diese Geschenkkarte wirklich kaufen?',
    'MyCard':'Meine Karte',
    'Please upload pictures':'Bitte Bilder hochladen',
    'Share audit list':'Prüfliste teilen',
    'Share page':'Seite teilen',
    'Audit result':'Prüfergebnis',
    'Share to the community':'In die Gemeinschaft teilen',
    'imshares1':'Schritteinführung',
    'imshares2':'Schritt 1: Teilen Sie das Produkt in sozialen Medien.',
    'imshares3':'Schritt 2: Machen Sie einen Screenshot der geteilten Produktseite und laden Sie ihn bei GoBuy hoch.',
    'Share Time':'Teilen Zeit',
    'Audit status':'Prüfstatus',
    'Reason for failure':'Grund für das Scheitern',
    'Pending approval':'Ausstehende Genehmigung',
    'Approved':'Genehmigt',
    'Audit failed':'Prüfung fehlgeschlagen',
    'Url Copied': 'Link erfolgreich kopiert, Weiterleitung zum Teilen...',
    "Points Logs": "Punkteprotokolle",
    "My Points": "Meine Punkte",
    "Go Excharge": "Zum Austausch gehen",
    "Confirm points excharge": "Sind Sie sicher, dass Sie alle Punkte in Guthaben umwandeln möchten?",
    'is not share': 'Sie haben die Freigabeaufgabe noch nicht abgeschlossen',
    'is buied': 'Sie haben heute bereits einen Kauf getätigt',
    'My card': 'Meine Karte',
    "Country/Region": "Land/Region",
    "Contact info": "Kontaktinformationen",
    "Please enter real name": "Bitte geben Sie den echten Namen ein",
    "Please enter Phone Number": "Bitte Telefonnummer eingeben",
    "Please enter State/Province/Region": "Bitte geben Sie Staat/Provinz/Region ein",
    "Please enter City": "Bitte Stadt eingeben",
    "Please enter Street Address": "Bitte Straßenadresse eingeben",
    "Please enter Postal Code": "Bitte Postleitzahl eingeben",
    "lucky_draw_winning_products": "Produkte, die im Gewinnspiel gewonnen wurden",
    "refundAdd": "Rückerstattungsantrag",
    "refundDescription": "Rückerstattungsbeschreibung",
    "productQualityIssue": "Produktqualitätsproblem",
    "logisticsTransportIssue": "Logistik- und Transportproblem",
    "sellerPlatformIssue": "Problem mit Verkäufer oder Plattform",
    "personalReason": "Persönlicher Grund",
    "otherSpecialCases": "Andere besondere Fälle",
    "hunt points rule": "Punkteregeln",
    "hunt points rule1": "1. Punkte verdienen: Benutzer erhalten 1 Punkte für jede 0.1 Dollar, die sie in den Glückskauf investieren",
    "hunt points rule2": "2. Punkte umtauschen: 1 Punkte = 0.01% Dollar",
    'Login Password': "Anmeldepasswort",
    "Level": "Stufe",

    "guide.Rewards": "Belohnungseinführung",
    "guide.title": "Anfängerhandbuch",
    "guide.Invitation.Reward": "Veranstaltungsbelohnung",
    "guide.Order.Sharing": "Order Sharing",
    "guide.section1.title": "Anleitung zum Glückskauf",
    "guide.section1.step1": "Kauf auswählen: Gehen Sie zur USD-Zone und wählen Sie Ihren Lieblingsartikel.",
    "guide.section1.step2": "Menge auswählen: Geben Sie die Anzahl der Anteile ein, an denen Sie teilnehmen möchten.",
    "guide.section1.step3": "Anzahl kaufen: Nur 0,1 $ für eine Einheit.",
    "guide.section1.step4": "Ziehung abwarten: Das System ermittelt automatisch den glücklichen Gewinner.",
    "guide.section2.title": "Anleitung zum Blindbox-Kauf",
    "guide.section2.step1": "Blindbox öffnen: Klicken Sie, um zur Blindbox-Zone zu gelangen.",
    "guide.section2.step2": "Jetzt teilnehmen: Zahlen Sie 1 USD.",
    "guide.section2.step3": "Preis enthüllen: Gewinnen Sie Preise im Wert von bis zu 3 Millionen USD.",
    "guide.section3.title": "Anleitung zum Kauf von Geschenkkarten",
    "guide.section3.step1": "Teilen Sie in der Community: Teilen Sie die Aktion jetzt und laden Sie Ihre Informationen hoch.",
    "guide.section3.step2": "Wählen Sie den Nennwert: Wählen Sie den Preis der Geschenkkarte frei aus.",
    "guide.section3.step3": "100 Geschenkkarten für nur 98 $ kaufen.",
    "guide.section3.step4": "Sofortiger Rückkauf: 100 % Rückkauf, verdienen Sie 2 $",
    "guide.tip.title": "Freundliche Tipps: Verpassen Sie diese großartigen Vorteile nicht",
    "guide.tip.luckyBuy": "Nur 0,1 USD Teilnahme, mit der Chance, Preise von 1 bis 50.000 USD zu gewinnen!",
    "guide.tip.luckyBuy1": "Team-Provisionsbelohnungen: Laden Sie Freunde zum Kauf ein und verdienen Sie bis zu 0,02 % Provision!",
    "guide.tip.luckyBuy2": "Punkte einlösen: Verdienen Sie 1 Punkt für jeden Glückskauf, 1000 Punkte = 0,1 USD!",
    "guide.tip.example": "Beispiel:",
    "guide.tip.example1": "Sie laden Benutzer A ein, A kauft 1000 USD → Sie erhalten 2 USD Provision.",
    "guide.tip.example11": "A lädt Benutzer B ein, B kauft 1000 USD → Sie erhalten weitere 1 USD Provision.",
    "guide.tip.boxTitle": "Blindbox-Lotterie",
    "guide.tip.box": "Einmalige Teilnahme für 1 USD, mit Preisen im Wert von bis zu 3 Millionen USD!",
    "guide.tip.cardTitle": "Geschenkkarten",
    "guide.tip.card": "Team-Provision: Laden Sie Freunde zum Kauf ein und verdienen Sie bis zu 0,04 % Provision!",
    "guide.tip.example2": "Wenn Sie Benutzer A einladen, eine Geschenkkarte im Wert von 100 $ zu kaufen, erhalten Sie eine Provision von 0,4 $.",
    "guide.tip.example3": "Wenn A Benutzer B einlädt und B eine Geschenkkarte über 100 $ kauft, erhalten Sie zusätzlich 0,2 $ Provision.",
    "guide.tip.callToAction": "Jetzt teilnehmen und Ihre Glücksreise beginnen!",
    "guide.warning.title": "Warm Reminder",
    "guide.warning.rule1": "What situations cause commission invalidation?",
    "guide.warning.answer1": "Using software or other platforms to maliciously obtain commissions will result in all commissions being deducted and account suspension once verified.",
    "guide.warning.rule2": "Can I earn commission by inviting myself?",
    "guide.warning.answer2": "No. We conduct manual checks, and any verified cheating will result in all commissions being deducted, invitation qualifications revoked, and account clearance.",
    "invite.title": "Vorteile sind da | Lade Freunde ein und gewinne 4 große Preise!",
    "invite.reward1.title": "Belohnung 1: Gruppe einladen, einfach USD + Geschenkkarten verdienen",
    "invite.reward1.item1": "Erhalten Sie für jede 10 erfolgreich eingeladenen neuen Mitglieder der Gruppe Rotpaket-Belohnungen!",
    "invite.reward1.item2": "Außerdem eine Geschenkkarte im Wert von 1 USD",
    "invite.reward1.item3": "Je mehr Sie einladen, desto mehr verdienen Sie! Rotpakete werden sofort gesendet, Geschenkkarten sind sofort einlösbar!",
    "invite.reward2.title": "Belohnung 2: Glückskauf, mühelos Provisionen verdienen",
    "invite.reward2.item1": "Sie verdienen Provision, wenn Ihre Freunde an Glückskauf-Aktivitäten teilnehmen!",
    "invite.reward2.item2": "Unbegrenzte Provision, je mehr sie kaufen, desto mehr verdienen Sie!",
    "invite.reward3.title": "Belohnung 3: Geschenkkarten",
    "invite.reward3.item1": "Sie erhalten sofort Provision, wenn Ihre Freunde Geschenkkarten kaufen!",
    "invite.reward3.item2": "Kostenloser Freigabelink, automatische Nachverfolgung, super einfache Bedienung:",
    "invite.reward3.item3": "Link senden → Freund bestellt → Auszahlung abwarten!",
    "invite.callToAction": "Laden Sie schnell Ihre Freunde ein, der Gruppe beizutreten, und bringen Sie alle Vorteile mit nach Hause! Spielen und verdienen wir zusammen!",
    "share.title": "GoBuy Gewinn teilen und 1 USD Geschenkkarte gewinnen",
    "share.subtitle": "Titel teilen",
    "share.content1": "Dank GoBuy Lucky Shopping für das Glück. Ein Mitglied hat heute eine kleine Investition getätigt, Preise gewonnen und erfolgreich ausgezahlt! ✨",
    "share.content2": "Jetzt sind Sie dran! Teilen Sie einfach Ihre Gewinn-Erfahrung und erhalten Sie eine kostenlose 1 USD GoBuy-Geschenkkarte! Verpassen Sie es nicht — einfach, lohnend und spaßig!",
    "share.inviteLink": "Fügen Sie Ihren Einladungscode bei:",
    "share.stepsTitle": "So machen Sie mit:",
    "share.step1": "Laden Sie einen Screenshot Ihres Kauf-/Bestellcodes im Glückskauf-Bereich hoch",
    "share.step2": "Laden Sie einen Screenshot der Nachricht „Herzlichen Glückwunsch, Sie haben gewonnen!“ hoch",
    "share.step3": "Laden Sie einen Screenshot Ihres Auszahlungsantrags und der erfolgreichen Transaktion hoch",
    "share.step4": "Senden Sie nach Abschluss der obigen Schritte Ihren Social-Media-Share-Screenshot zur Verifizierung an den Kundensupport",
    "share.email": "Kundensupport-E-Mail:",
    "share.footer": "Möge das Glück mit Ihnen sein — spielen Sie weiter, gewinnen Sie weiter! GoBuy — macht Einkaufen jeden Tag spaßig und lohnend!",
    "doubleBet.title": "Wettwunder｜3 einfache Schritte, kehren Sie das Ergebnis um und gewinnen Sie große Preise!",
    "doubleBet.step1": "Runde 1: Wählen Sie die $1-Zone, kaufen Sie $0,5, kaufen Sie 5 Einheiten und hören Sie auf, wenn Sie gewinnen.",
    "doubleBet.step2": "Wenn nicht gewonnen, Runde 2: Wählen Sie die $3-Zone, kaufen Sie $1,5, kaufen Sie 15 Einheiten und hören Sie auf, wenn Sie gewinnen.",
    "doubleBet.step3": "Wenn immer noch nicht gewonnen, Runde 3: Wählen Sie die $8-Zone, kaufen Sie $4, kaufen Sie 40 Einheiten, herzlichen Glückwunsch zum Gewinn.",
    "doubleBet.step4": "Nach dem Gewinn können Sie die Verluste aus den vorherigen Runden decken und einen Gewinn erzielen, dann starten Sie wieder mit Runde 1.",
    "invite.reward4.title": "Belohnung 4: Begrenzte Vorteile | Exklusive Geschenke für neue Nutzer",
    "invite.reward4.step1": "Kostenlose Teilnahme an 1 Glückskauf",
    "invite.reward4.step2": "Kostenlose Aktivierung einer 1 Mystery Box Lotterie",
    "invite.reward4.step3": "Erfüllen Sie die angegebenen Aufgaben und erhalten Sie eine zusätzliche Bargeldprämie von 1 $",
    "reward.register.title": "Registrierungsbelohnung",
    "reward.register.point1": "Neue Benutzer erhalten nach der Registrierung einen kostenlosen Lucky Buy.",
    "reward.register.point2": "Treten Sie nach der Registrierung der Gruppe bei, um an der roten Umschlag-Aktion teilzunehmen.",
    "reward.task.title": "Aufgabenbelohnung",
    "reward.task.point1": "Melden Sie sich als Gast an und öffnen Sie eine Blindbox.",
    "reward.task.point2": "Erfüllen Sie die folgenden Lucky Buy-Aufgaben (jeweils einmal pro Zone):",
    "reward.task.subtask1": "$1-Zone: einmal für $0.5 kaufen",
    "reward.task.subtask2": "$3-Zone: einmal für $1.5 kaufen",
    "reward.task.subtask3": "$8-Zone: einmal für $4 kaufen",
    "reward.task.point3": "Erfüllen Sie beide Aufgaben und erhalten Sie eine $1-Prämie!",
    "reward.share.title": "Teilen-Belohnung",
    "reward.share.desc": "Ich habe gerade eine Überraschungsbox und ein Glückslos bei GoBuy gewonnen!",
    "reward.share.desc3": "Gleich nach der Registrierung hatte ich Glück – einfach großartig!",
    "reward.share.desc4": "✨Teile einen Screenshot deines Gewinns und erhalte 1 USD Belohnung.",
    "reward.share.desc1": "Lade 10 Freunde ein und erhalte 1 $, sobald sie sich registriert haben. Bei 1.000 Einladungen bekommst du 100 $ Belohnung – ohne Limit: je mehr Einladungen, desto mehr Belohnungen!",
    "reward.invite.title": "Einladungsbelohnung",
    "reward.invite.desc": "Lade erfolgreich 10 Freunde ein und schließe deren Registrierung ab.",
    "reward.share.desc2": "Erfülle die oben genannten Aufgaben, um deine Belohnungen für Teilen und Einladen zu erhalten!",
    "reward.invite.desc1": "Erfülle die Aufgaben, um deine Einladung-Belohnung zu erhalten!",
    "account.bank": "Bank",
    "account.name": "Kontobezeichnung",
    "bank.name": "Bankname",
    "account.number": "Kontonummer",
    "account.ifsc": "IFSC-Code",
    "account.type": "Kontotyp",
    "bank.upi.code": "UPI-Code",
    "bank.upi": "UPI-Scan",
    "save.img.save": "Langes Drücken auf das Bild oben zum Speichern",
    "bank.pay.tip": "Hinweis: Bitte geben Sie beim Überweisen den genauen INR-Betrag ein, sonst kann das System den Zahlungseingang nicht automatisch erkennen.",
    "bank.upi.order": "UPI-Transaktions-ID / Referenznummer",
    "Please enter a upi order": "Bitte geben Sie die UPI-Transaktions-ID / Referenznummer ein",

    "guide.title": "User Guide",
    "guide.section1.title": "Lucky Buy",
    "guide.section1.step1": "Each $0.1 = 1 entry",
    "guide.section1.step2": "System randomly draws → Win $1–$50,000",

    "guide.section2.title": "Blind Box",
    "guide.section2.step1": "Each $1 = 1 entry this round",
    "guide.section2.step2": "Win up to $3,000,000 jackpot",

    "guide.section3.title": "Gift Card",
    "guide.section3.step1": "$98 = $100 Gift Card",
    "guide.section3.step2": "System buyback → Earn $2 profit",

    "guide.tip.callToAction": "Join Now",

    "guide.Invitation.Reward": "Invitation Rewards",
    "reward.register.title": "Registration Reward",
    "reward.register.point1": "New users register → 🎟️ Get 1 Lucky Buy chance",
    "reward.register.point2": "✨ Automatically granted, no need to apply",

    "reward.recharge.title": "First Recharge Reward",
    "reward.recharge.point1": "New users' first recharge → 🎁 Get $2 reward",
    "reward.recharge.point2": "📩 Customer service email: gobuyusa888@gmail.com",
    "reward.task.point3": "Complete tasks to unlock more rewards",

    "reward.invite.title": "Invite Friends Reward",
    "reward.invite.point1": "Invite friends to recharge → 🎁 Get $1 reward",
    "reward.invite.point2": "No limit, the more invites, the more rewards!",
    "reward.invite.point3": "Automatically granted, no need to apply",

    "share.rewardTitle": "Sharing Reward",
    "share.rewardStep1": "Share your Lucky Buy / Blind Box / Gift Card winning screenshot to the community",
    "share.rewardStep2": "Share once = Reward $1",
    "share.rewardStep3": "Each user can claim only once",
    "share.email": "Please send email to gobuyusavip@gmail.com",

    "share.guestTitle": "Guest Task Reward",
    "share.guestStep1": "Complete the following 2 tasks:",
    "share.guestStep2": "1️⃣ Purchase 1 Lucky Buy",
    "share.guestStep3": "2️⃣ Purchase 3 Blind Boxes",
    "share.guestStep4": "⚠️ Each user can claim only once",
    "share.guestContact": "Customer Service Email: gobuyusa888@gmail.com",

    "share.teamTitle": "Team Reward",
    "share.teamStep1": "🔗 Users registered through your invitation link = your team members",
    "share.teamStep2": "🏆 Reward rules:",
    "share.teamStep3": "• Invite 10 active members → Reward $1",
    "share.teamStep4": "• Invite 1000 active members → Reward $100",
    "share.teamNote": "⚠️ Active members = users who recharge and complete at least one purchase (Gift Card / Blind Box / Lucky Buy).",
    "share.teamContact": "Customer Service Email: gobuyusa888@gmail.com",

    "guest.rewardTitle": "Guest Task Reward",
    "guest.intro": "Complete the following 2 tasks:",
    "guest.task1": "Purchase 1 Blind Box",
    "guest.task2": "Purchase 3 Lucky Draws",
    "guest.limit": "Each user can claim once only",

    "team.rewardTitle": "Team Reward",
    "team.ruleIntro": "Users registered through your invitation link = your team members",
    "team.ruleTitle": "Reward Rules:",
    "team.rule1": "Invite 10 active members → Reward $1",
    "team.rule2": "Invite 1000 active members → Reward $100",
    "team.note": "Active member = A user who registers, recharges, and makes at least one purchase (Gift Card / Mystery Box / Lucky Draw).",

    
    "reward.firstCharge.title": "First Deposit Reward",
    "reward.firstCharge.point1": "New users first deposit → 🎁 get $2 bonus",
}
export default German
